import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BUILD_INFO } from '@app/build-info';


@Component({
  selector: 'app-welcome',
  standalone: true,
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {

    readonly version = environment.version;

    readonly build = BUILD_INFO;

}